import { dateAva } from '../../../api/bookingAPI';
import { getDateDetailsFun, getDetailsFun } from '../../../api/infoAPI';
import errorHandle from '../../../utils/errorHandle';

export default async function fetchTripData(type, packId, setLoading, setPackData, setPackDates) {
    setLoading(true);
    try {
        // for getDateDetailsFun you get an array of objects with tripDate id, start and end date of each
        const allData = await getDetailsFun(type, packId);
        setPackData(allData.data.packdata);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}

export async function fetchTripDate(data, type) {
    try {
        const res = await dateAva(data, type);
        return res.data.data;
    } catch (error) {
        errorHandle(error);
        return null;
    }
}
